import { render, staticRenderFns } from "./AMisRenderer.vue?vue&type=template&id=61a19702&scoped=true"
import script from "./AMisRenderer.vue?vue&type=script&lang=js"
export * from "./AMisRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a19702",
  null
  
)

export default component.exports